import React from "react";

const GridListWithImage = ({
                               title = [
                                   <>
                                       <span className="underline decoration-blue-500">Components</span>
                                   </>
                               ],
                               features01 = [
                                   {
                                       title: "",
                                       imgUrl: "",
                                       list01: "",
                                       list02: "",
                                       list03: ""
                                   }
                               ],
                               features02 = [
                                   {
                                       title: "",
                                       imgUrl: "",
                                       list01: "",
                                       list02: "",
                                       list03: "",
                                       list04: "",
                                       list05: "",
                                   }
                               ],
                               features03 = [
                                   {
                                       title: "",
                                       imgUrl: "",
                                       list01: "",
                                       list02: "",
                                       list03: "",
                                       list04: "",
                                       list05: "",
                                       badge: ""
                                   }
                               ],
                               features04 = [
                                   {
                                       title: "",
                                       imgUrl: "",
                                       list01: "",
                                       list02: "",
                                       list03: "",
                                       list04: "",
                                       badge: ""
                                   }
                               ],
                               features05 = [
                                   {
                                       title: "",
                                       imgUrl: "",
                                       list01: "",
                                       list02: "",
                                       list03: "",
                                       badge01: "",
                                       badge02: "",
                                       badge03: "",
                                   }
                               ]
                           }) => {
    return (
        <section className="bg-white dark:bg-gray-900">
            <div className="max-w-[96rem] mx-auto px-6 py-[70px] lg:py-[100px]">
                <h1 className="text-h1 font-bold capitalize text-gray-800 dark:text-white lg:text-[40px]">
                    {title}
                </h1>

                <p className="mt-4 text-body text-gray-600 xl:mt-4">
                    Generative AI 및 Prompt Engineering 관련 SCI 논문 실적 보유.
                    AI/ML/DL 관련 특허 다수 보유.
                    <br className="hidden lg:block"/>
                    다양한 산업분야의 기술 R&D 경험을 바탕으로, ICT 기반
                    창의적인 융합서비스 설계 및 수행 역량을 갖춘 유능한 인재들로
                    구성되어 있습니다.
                </p>

                <div className="mt-8 flex flex-col-reverse lg:flex-row lg:items-center xl:mt-12">
                    <div
                        className="grid w-full grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
                        {features01.map((feature, i) => (
                            <div
                                className="flex flex-col justify-start gap-5 rounded-xl border border-gray-200 p-6 lg:min-h-[360px] lg:max-h-[440px] overflow-hidden"
                                key={i}
                            >
                                <div
                                    className="bg-tile-violet rounded-[8px] p-[10px] w-[55px] h-[55px] flex align-center justify-center drop-shadow-tile-violet">
                                    <img src={feature.imgUrl} alt=""/>
                                </div>
                                <h1 className="text-[20px] font-semibold leading-6 capitalize text-black dark:text-white">
                                    {feature.title}
                                </h1>
                                <ul className="list-outside space-y-2 pl-[15px]">
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list01}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list02}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list03}
                                    </li>
                                </ul>
                            </div>
                        ))}
                        {features02.map((feature, i) => (
                            <div
                                className="flex flex-col justify-start gap-5 rounded-xl border border-gray-200 p-6 lg:min-h-[360px] lg:max-h-[440px] overflow-hidden"
                                key={i}
                            >
                                <div
                                    className="bg-tile-sky rounded-[8px] p-[10px] w-[55px] h-[55px] flex align-center justify-center  drop-shadow-tile-sky">
                                    <img src={feature.imgUrl} alt=""/>
                                </div>
                                <h1 className="text-[20px] font-semibold leading-6 capitalize text-black dark:text-white">
                                    {feature.title}
                                </h1>
                                <ul className="list-outside space-y-2 pl-[15px]">
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list01}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list02}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list03}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list04}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list05}
                                    </li>
                                </ul>
                            </div>
                        ))}
                        {features03.map((feature, i) => (
                            <div
                                className="flex flex-col justify-start gap-5 rounded-xl border border-gray-200 p-6 lg:min-h-[360px] lg:max-h-[440px] overflow-hidden"
                                key={i}
                            >
                                <div className="flex justify-start gap-5 items-center">
                                    <div
                                        className="bg-tile-rose rounded-[8px] p-[10px] w-[55px] h-[55px] flex align-center justify-center drop-shadow-tile-rose">
                                        <img src={feature.imgUrl} alt=""/>
                                    </div>

                                    <span className="bg-purple-500 rounded-[6px] justify-start text-white text-sm font-bold leading-none
                                    px-3 py-1.5">공식파트너사</span>
                                </div>
                                <h1 className="text-[20px] font-semibold leading-6 capitalize text-black dark:text-white">
                                    {feature.title}
                                </h1>
                                <ul className="list-outside space-y-2 pl-[15px]">
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list01}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list02}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list03}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list04}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list05}
                                    </li>
                                </ul>
                            </div>
                        ))}
                        {features04.map((feature, i) => (
                            <div
                                className="flex flex-col justify-start gap-5 rounded-xl border border-gray-200 p-6 lg:min-h-[360px] lg:max-h-[440px] overflow-hidden"
                                key={i}
                            >
                                <div className="flex justify-start gap-5 items-center">
                                    <div
                                        className="bg-tile-databricks rounded-[8px] p-[13px] w-[55px] h-[55px] flex align-center justify-center drop-shadow-tile-databricks">
                                        <img src={feature.imgUrl} alt=""/>
                                    </div>

                                    <span className="bg-purple-500 rounded-[6px] justify-start text-white text-sm font-bold leading-none
                                    px-3 py-1.5">공식파트너사</span>
                                </div>
                                <h1 className="text-[20px] font-semibold leading-6 capitalize text-black dark:text-white">
                                    {feature.title}
                                </h1>
                                <ul className="list-outside space-y-2 pl-[15px]">
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list01}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list02}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list03}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list04}
                                    </li>
                                </ul>
                            </div>
                        ))}
                        {features05.map((feature, i) => (
                            <div
                                className="flex flex-col justify-start gap-5 rounded-xl border border-gray-200 p-6 lg:min-h-[360px] lg:max-h-[440px] overflow-hidden"
                                key={i}
                            >
                                <div
                                    className="bg-tile-sky rounded-[8px] p-[10px] w-[55px] h-[55px] flex align-center justify-center drop-shadow-tile-sky">
                                    <img src={feature.imgUrl} alt=""/>
                                </div>
                                <h1 className="text-[20px] font-semibold leading-6 capitalize text-black dark:text-white">
                                    {feature.title}
                                </h1>
                                <ul className="list-outside space-y-2 pl-[15px]">
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list01}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list02}
                                    </li>
                                    <li className="text-[16px] font-normal leading-5 tracking-tight text-gray-800 dark:text-gray-300 list-disc">
                                        {feature.list03}
                                    </li>
                                </ul>
                                <ul className="flex row justify-start items-center gap-2 w-full">
                                    <li><img src={feature.badge01} alt="" className="h-20" /></li>
                                    <li><img src={feature.badge02} alt="" className="h-24" /></li>
                                    <li><img src={feature.badge03} alt="" className="h-24" /></li>
                                </ul>
                            </div>
                        ))}
                    </div>
                    {/*<div className=" justify-center lg:flex lg:w-1/2 ">*/}
                    {/*    <img*/}
                    {/*        className="h-[28rem] w-[28rem] flex-shrink-0  object-contain xl:h-[34rem] xl:w-[34rem]"*/}
                    {/*        src="/img/introduce-02.png"*/}
                    {/*        alt=""*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            </div>
        </section>
    );
};

export default GridListWithImage;
